/* eslint-disable prettier/prettier */
export default () =>({
  courtOrderData:null,
  status: "extracting",
  segipResponse: null,
  listPrivatedLibertyPersons:null,
  countPersonsCenter:null,
  dataToEdit:null,
  statusEdit: "not editing",
  chartData:null,
  chartStatus:null,
  chartDataTwoParams:null,
})
